import { ONE_DAY_MILLI } from '@/utils/dateUtil'

export const timeOptions = [{
  label: '1 Week',
  value: 7 * ONE_DAY_MILLI,
}, {
  label: '2 Weeks',
  value: 14 * ONE_DAY_MILLI,
}, {
  label: '3 Weeks',
  value: 21 * ONE_DAY_MILLI,
}, {
  label: '1 Month',
  value: 31 * ONE_DAY_MILLI,
}, {
  label: 'Show All',
  value: 0,
}]

export const wpTimeOptions = [{
  label: '1 day',
  value: ONE_DAY_MILLI,
}, {
  label: '1 Week',
  value: 7 * ONE_DAY_MILLI,
}, {
  label: '2 Weeks',
  value: 14 * ONE_DAY_MILLI,
}, {
  label: '1 Month',
  value: 31 * ONE_DAY_MILLI,
}, {
  label: 'Show All',
  value: 0,
}]

export const PROJECT_STATUS_FOR_WP = {
  DRAFT: 'DRAFT',
  SUBMITTED: 'SUBMITTED',
  CANCELLED: 'CANCELLED',
  WITHDRAWN: 'WITHDRAWN',
  COMPLETED: 'COMPLETED',
}

export const TENANT_PROJECT_TYPES = {
  Fitout: 'Fitout',
  Reinstatement: 'Reinstatement',
  Facade: 'Facade',
}
